import { useMutation } from "@tanstack/react-query";
import { type RequestSafetyHelpInput, requestSafetyHelp } from "../services/safetyHelpService";
import { captureSafetyLocation } from "../utils/captureSafetyLocation";

export type RequestSafetyHelpMutationInput = {
  message?: string;
  shareLocation: boolean;
};

export function useRequestSafetyHelp() {
  return useMutation({
    mutationFn: async (input: RequestSafetyHelpMutationInput) => {
      let location: RequestSafetyHelpInput["location"] = null;
      if (input.shareLocation) {
        location = await captureSafetyLocation();
      }
      return requestSafetyHelp({
        message: input.message?.trim() || null,
        location,
      });
    },
  });
}
